export default {
      id: "i-arrow-right-cart-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/sprite.svg#i-arrow-right-cart",
      toString: function () {
        return this.url;
      }
    }